import uniqBy from 'lodash/uniqBy';
import { SearchResultItem } from '../search/types';

export const duplicateSearchResults = (results: SearchResultItem[]) => {
  const uniqueArray = uniqBy(results, item => item.id);
  return uniqueArray.length !== results.length;
};
